<template>
  <div class="main drugsManagement">
    <h2 class="is-print-hide title-area">
      <div class="title">
        <span class="main-title">药品管理</span>
        <span class="sub-title">仅展示自行添加的药品信息</span>
      </div>
    </h2>

    <el-tabs v-model="activeName">
      <el-tab-pane label="现金处方药品管理" name="cash">
        <CashDrugList />
      </el-tab-pane>

      <el-tab-pane label="门统处方药品管理" name="prescription">
        <ClinicPlanDrugList />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CashDrugList from './cashDrugList';
import ClinicPlanDrugList from './clinicPlanDrugList.vue';

export default {
  name: 'drugsManagement',
  components: {
    CashDrugList,
    ClinicPlanDrugList
  },
  data() {
    return {
      activeName: 'cash'
    };
  },
  mounted() {
    // 根据URL参数设置默认tab
    const { tab } = this.$route.query;
    if (tab === 'prescription') {
      this.activeName = 'prescription';
    }
  }
};
</script>

<style lang="scss" scoped>
.drugsManagement {
  .title-area {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    .sub-title {
      margin-left: 8px;
      font-size: 12px;
      color: #bdbdbd;
    }

    .handle-bar {
      .btn {
        width: 132px;
        color: #ebb436;
        border: 1px solid #ebb436;
      }
    }
  }
}
</style>
